/*
 * @Description: 新增/编辑等级销售模版
 * @Author: 杨志航
 * @Date: 2026-02-12 15:11:20
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  Select,
  message,
  Upload,
  Icon,
  Modal,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { uploadDragger } from '@/utils/uploadDragger'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item
const Option = Select.Option
const { Dragger } = Upload

let draggerObj = {}

const AddSaleTemplate = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setAddVisible, getList, editData, projectList } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    draggerObj = uploadDragger({
      accept: '.pdf',
      limitNum: 1,
      limitSize: 5,
    })
    const { id, fileName, fileInfo, projectId } = editData
    if (id) {
      setFieldsValue({
        fileInfo: [{
          uid: '-1',
          name: fileInfo.name,
          status: 'done',
          url: fileInfo.url,
        }],
        fileName,
        projectId,
      })
    }
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (editData.id) {
          vals.id = editData.id
        }
        const { url, name } = vals.fileInfo[0]
        vals.fileInfo = { url, name }
        setSaveLoading(true)
        api.setAchSaleTpl(vals).then(() => {
          setSaveLoading(false)
          setAddVisible(false)
          message.success(editData.id ? '编辑成功' : '添加成功')
          getList()
        }).catch(err => {
          setSaveLoading(false)
          const { code, msg } = err
          if (code === 2) {
            Modal.confirm({
              content: msg,
              onOk() {
                setSaveLoading(true)
                vals.forceUpdate = 1
                api.setAchSaleTpl(vals).then(() => {
                  setSaveLoading(false)
                  setAddVisible(false)
                  message.success('添加成功')
                  getList()
                }).catch(err => console.log(err))
              }
            })
          }
        })
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="等级销售模板名称">
          {getFieldDecorator('fileName', {
            rules: [{ required: true, message: '请输入等级销售模板名称' }]
          })(
            <Input placeholder="请输入等级销售模板名称" maxLength={50} />
          )}
        </FormItem>
        <FormItem label="关联项目">
          {getFieldDecorator('projectId', {
            rules: [{ required: true, message: '请选择关联项目' }]
          })(<Select 
            placeholder="请选择关联项目"
            showSearch
            allowClear
            optionFilterProp="children"
            disabled={!!editData.id}
          >
            {projectList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)}
          </Select>)}
        </FormItem>
        <Form.Item label="上传附件">
          {getFieldDecorator('fileInfo', {
            valuePropName: 'fileList',
            getValueFromEvent: draggerObj.normFile,
            rules: [{ required: true, message: '请上传岗位说明书' }]
          })(
            <Dragger {...draggerObj}>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
              <p className="ant-upload-hint">
                支持扩展名：.pdf
              </p>
            </Dragger>
          )}
        </Form.Item>
        <BtnGroup onCancel={() => setAddVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  )
}

export default Form.create()(AddSaleTemplate)
